// CancelGameModal.jsx
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CancelGameModal = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center p-4">
      <Card className="w-full max-w-md mx-auto bg-white shadow-[0_0_15px_rgba(0,0,0,0.1)]">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
          <CardTitle className="text-xl font-bold">{t('game.cancel.title')}</CardTitle>
          <Button
            variant="outline"
            size="sm"
            className="h-8 w-8 p-0 hover:bg-stone-100"
            onClick={onCancel}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">{t('game.cancel.close')}</span>
          </Button>
        </CardHeader>
        <CardContent>
          <p className="mb-6 text-stone-600">{t('game.cancel.message')}</p>
          <div className="flex justify-center gap-2">
            <Button
              variant="outline"
              onClick={onCancel}
              className="border-stone-800 text-stone-800 hover:bg-stone-50"
            >
              {t('game.cancel.stay')}
            </Button>
            <Button
              onClick={onConfirm}
              className="bg-stone-800 hover:bg-stone-900 text-white transition-colors leading-none w-fit"
            >
              {t('game.cancel.confirm')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CancelGameModal;